import {
  LOADING_OVERVIEW,
  STOP_LOADING_OVERVIEW,
  CHANGE_DROPDOWN_OPTION,
  SET_OVERVIEW,
  UPDATE_OVERVIEW,
  RESET_OVERVIEW,
} from '../types'

const initialState = {
  docFromYou: {
    Completed: 0,
    Rejected: 0,
    Expired: 0,
  },
  docToYou: {
    Completed: 0,
    Rejected: 0,
    Expired: 0,
  },
  loading: false,
  dropdownOption: 1,
  isInitiated: false,
}

const oveviewReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADING_OVERVIEW:
      return {
        ...state,
        loading: true,
      }
    case STOP_LOADING_OVERVIEW:
      return {
        ...state,
        loading: true,
      }
    case CHANGE_DROPDOWN_OPTION:
      return {
        ...state,
        dropdownOption: action.payload,
      }
    case SET_OVERVIEW:
      return {
        ...state,
        ...action.payload,
        loading: false,
        isInitiated: true,
      }
    case UPDATE_OVERVIEW:
      state[action.payload.type][action.payload.status]++
      return {
        ...state,
        loading: false,
      }

    case RESET_OVERVIEW:
      return initialState

    default:
      return state
  }
}

export default oveviewReducer
